@if (isLoggedIn) {
  <div class="discovery-view">
      <p-tabView (onChange)="onTabChange($event)">
          <!-- Whenever tabs are reordered or modified so that their indexes change,
    all references to "selectedTab" must be updated to reflect the updated
    indexes (for example, see the "Events" and "Status" tabs below) -->
          <p-tabPanel header="Devices/Maps" headerStyleClass="data-tab" [selected]="true">
              <devices [selected]="selectedTab == DevicesTabIndex"></devices>
          </p-tabPanel>
          <p-tabPanel header="Discovery Runs" headerStyleClass="data-tab">
              <discresult-list [discovery]="discovery"></discresult-list>
          </p-tabPanel>
          <p-tabPanel header="Reports" headerStyleClass="data-tab">
              <reports></reports>
          </p-tabPanel>
          <p-tabPanel header="Events" headerStyleClass="data-tab">
              <events [discovery]="discovery" [selected]="selectedTab == EventsTabIndex"></events>
          </p-tabPanel>
          <p-tabPanel header="Status" headerStyleClass="data-tab">
              <sched-disc-status [discovery]="discovery" [selected]="selectedTab == StatusTabIndex"></sched-disc-status>
          </p-tabPanel>
          <p-tabPanel header="Discovery Settings" headerStyleClass="config-tab">
              <sched-disc-config-basic [Discovery]="discovery"></sched-disc-config-basic>
              <sched-disc-config-events [Discovery]="discovery"></sched-disc-config-events>
              <div style="height: 500px;"></div>
          </p-tabPanel>
          <p-tabPanel header="Protocols / Credentials" headerStyleClass="config-tab">
              <sched-disc-config-protocols [Discovery]="discovery"></sched-disc-config-protocols>
          </p-tabPanel>
          <p-tabPanel header="Include / Exclude Scopes" headerStyleClass="config-tab">
              <sched-disc-config-scopes [Discovery]="discovery"></sched-disc-config-scopes>
          </p-tabPanel>
          <p-tabPanel header="Advanced Settings" headerStyleClass="config-tab">
              <sched-disc-config-advanced [Discovery]="discovery"></sched-disc-config-advanced>
          </p-tabPanel>
          <p-tabPanel header="Schedule" headerStyleClass="config-tab">
              <sched-disc-config-schedule [Discovery]="discovery"></sched-disc-config-schedule>
          </p-tabPanel>
          <p-tabPanel header="PRTG Export" headerStyleClass="config-tab">
              <sched-disc-config-prtg [Discovery]="discovery"></sched-disc-config-prtg>
          </p-tabPanel>
          @if (isITGlueTabVisible()) {
          <p-tabPanel header="ITGlue Export" headerStyleClass="config-tab">
              <sched-disc-config-itglue [Discovery]="discovery"></sched-disc-config-itglue>
          </p-tabPanel>
          }
          @if (isHaloTabVisible()) {
          <p-tabPanel header="HaloITSM Export" headerStyleClass="config-tab">
              <sched-disc-config-halo [Discovery]="discovery"></sched-disc-config-halo>
          </p-tabPanel>
          }
          @if (isHuduTabVisible()) {
          <p-tabPanel header="Hudu Export" headerStyleClass="config-tab">
              <sched-disc-config-hudu [Discovery]="discovery"></sched-disc-config-hudu>
          </p-tabPanel>
          }
          @if (isAssetPandaTabVisible()) {
          <p-tabPanel header="AssetPanda Export" headerStyleClass="config-tab">
              <sched-disc-config-assetpanda [Discovery]="discovery"></sched-disc-config-assetpanda>
          </p-tabPanel>
          }
          @if (isJiraTabVisible()) {
          <p-tabPanel header="Jira Export" headerStyleClass="config-tab">
              <sched-disc-config-jira [Discovery]="discovery"></sched-disc-config-jira>
          </p-tabPanel>
          }
          <p-tabPanel header="Tools" headerStyleClass="config-tab">
              <tools></tools>
          </p-tabPanel>
      </p-tabView>
    <span class="uv-save-button">
      <button type="button" pButton icon="fa fa-save"
        (click)="onSave()" [disabled]="!isSaveEnabled()" label="Save Discovery Changes">
      </button>
    </span>
    <p-dialog [(visible)]="showInvalidTempChangesDialog" appendTo="body">
      <p-header>
        <span>Invalid Changes</span>
      </p-header>
      <p>
        Invalid changes have been made in the following tabs and cannot be saved.
      </p>
      <ul>
        @for (tabName of tabsWithErrors; track tabName) {
          <li>{{tabName}}</li>
        }
      </ul>
      <p>
        Select one of the options below.
      </p>
      <p-footer>
        <button type="button" pButton (click)="onDiscardTempChanges()" label="Discard Changes"></button>
        <button type="button" pButton (click)="onCancelSave()" label="Cancel"></button>
      </p-footer>
    </p-dialog>
  </div>
}

